import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const roundLabels = ['Current round of feedback', 'Previous round of feedback'];

const styles = {
  tooltip: ({ palette }) => ({
    padding: 1.5,
    borderRadius: 2,
    backgroundColor: palette.colors.darkBlue,
    color: palette.common.white,
  }),
};

export const RoundComparisonTooltip = ({ active = false, payload = [] }) => {
  if (!active || !payload?.length) {
    return null;
  }

  const { name } = payload[0].payload;

  return (
    <Box sx={styles.tooltip}>
      <Typography variant="caption" component="p" color="inherit">
        {name}
      </Typography>
      {payload.map((item, index) => (
        <Typography key={item.dataKey} variant="caption" component="p" color="inherit">
          {index === 0 ? roundLabels[0] : roundLabels[1]}: {item.value}
        </Typography>
      ))}
    </Box>
  );
};

RoundComparisonTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.shape({})),
};
